import { type FC, useCallback, useState } from 'react';

import { ChipsOption } from 'shared/models/ChipsOption';
import { PikHistoryItemsService } from 'shared/services/ChipsDataService';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { PikHistory } from './PikHistory';
import { type IPikHistoryItem, PikHistoryItem } from './external/models/PikHistoryItem';

const pikHistoryItemsService = new PikHistoryItemsService([
  new PikHistoryItem(
    new ChipsOption('1994'),
    'Начало пути',
    'В 1994 году мы основали «Первую Ипотечную Компанию» — будущий ПИК',
  ),
  new PikHistoryItem(
    new ChipsOption('1998'),
    'Первая ипотека в России',
    'ПИК первым в России запустил ипотечные программы, сделав покупку жилья доступнее',
  ),
  new PikHistoryItem(
    new ChipsOption('2002'),
    'Первые облигации',
    'Строительные компании в России не продавали ценные бумаги на бирже. Мы стали первыми, выпустив собственные рублёвые облигации в 2002 году',
  ),
  new PikHistoryItem(new ChipsOption('2008'), 'Лидер рынка', 'ПИК вошёл в число системообразующих компаний России'),
  new PikHistoryItem(
    new ChipsOption('2011'),
    'Новый стандарт жилых кварталов',
    'Мы первыми начали создавать не просто дома, а комфортную среду: с продуманным благоустройством, детскими площадками, школами и детскими садами рядом. Этот подход стал стандартом для всей отрасли.',
  ),
  new PikHistoryItem(
    new ChipsOption('2015'),
    'Крупнейший девелопер Европы',
    'Компания ПИК стала самым крупным девелопером в Европе по объёму жилищного строительства',
  ),
  new PikHistoryItem(
    new ChipsOption('2017'),
    'Построили рекордные 2 млн м² недвижимости',
    'ПИК создал производственный комплекс из 5 заводов и существенно ускорил строительство. Жители стали получать квартиры быстрее. В 2017 году мы впервые построили более 2 млн м².',
  ),
  new PikHistoryItem(
    new ChipsOption('2018'),
    'Надёжность с эскроу',
    'Мы первыми в России провели крупную сделку с эскроу-счётом, сделав покупку квартир на стадии строительства безопасной. С 2019 года эскроу стали обязательными для всех.',
  ),
  new PikHistoryItem(
    new ChipsOption('2019'),
    'Провели первую онлайн-сделку',
    'ПИК стал первым российским девелопером, который запустил онлайн-оплату недвижимости банковской картой на сайте',
  ),
  new PikHistoryItem(
    new ChipsOption('2020'),
    'Полный переход в онлайн',
    'Во время пандемии мы перевели в онлайн весь процесс: от выбора квартиры и ипотеки до покупки и аренды, — изменив рынок',
  ),
  new PikHistoryItem(
    new ChipsOption('2021'),
    'Построили 3 млн м² и новый бренд',
    'Сдали рекордные 3 млн м² жилья и запустили бренд Forma — проекты бизнес-класса',
  ),
  new PikHistoryItem(
    new ChipsOption('2022'),
    'Новые продукты для клиентов',
    'Провели первую в России сделку по IT-ипотеке — специальной программе для сотрудников IT-компаний с выгодными условиями. В том же году запустили новую линейку проектов повышенного комфорта ПИК+ и представили маркетплейс «ПИК-Маркет» — удобную платформу для выбора и покупки товаров и услуг для дома.',
  ),
  new PikHistoryItem(
    new ChipsOption('2023'),
    'Пространства для бизнеса',
    'Сделали каждый квартал ПИК уникальным и удобным. Создали бренд Parametr для разработки современных офисов, промзон и логистических парков.',
  ),
  new PikHistoryItem(
    new ChipsOption('2024'),
    '«Серия плюс»',
    'Представили «Серию плюс» — проекты с лучшими решениями ПИК: уникальной архитектурой, умными планировками и продуманной инфраструктурой для жизни',
  ),
]);

export const PikHistoryContainer: FC = () => {
  const { logger } = useApplicationContext();

  const [activePikHistoryItem, setActivePikHistoryItem] = useState<IPikHistoryItem>(pikHistoryItemsService.defaultItem);

  const handleChange = useCallback<(value: string[]) => void>(
    value => {
      setActivePikHistoryItem(pikHistoryItemsService.getActiveItem(value[0], logger));
    },
    [logger],
  );

  return (
    <PikHistory
      activePikHistoryItem={activePikHistoryItem}
      chipsOptions={pikHistoryItemsService.chipsOptions}
      onChange={handleChange}
    />
  );
};
